<template>
  <div>
    <div class="row">
      <div class="col-sm-4">
        <base-input
          label="Contract Number / Draft Contract No"
          v-model="contractorDraftNumber"
        >
        </base-input>
        <base-button type="primary" @click="search">Search</base-button>
      </div>
    </div>
    <div class="row">
      <div class="col-sm-12">
        <el-table style="width: 100%" :data="result">
          <el-table-column label="CONTRACT NUMBER" prop="contractNumber" />
          <el-table-column
            label="DRAFT CONTRACT NUMBER"
            prop="draftContractNo"
          />
          <el-table-column>
            <template #default="scope">
              <div>
                <base-button
                  type="danger"
                  @click="cancelRevise(scope.row.contract_id)"
                  >Cancel Revise</base-button
                >
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
  </div>
</template>

<script setup>
import baseInput from '@/components/newUI/Inputs/BaseInput';
import baseButton from '@/components/newUI/BaseButton';
import { ref } from 'vue';
import { request } from '@/network/request';
import { ElMessage } from 'element-plus';

const contractorDraftNumber = ref();
const result = ref([]);

const search = async () => {
  request({
    url: '/admin/getCancelReviseList',
    method: 'get',
    params: {
      contract_number: contractorDraftNumber.value,
    },
  }).then((res) => {
    result.value = res.data;
  });
};

const cancelRevise = async (contract_id) => {
  request({
    url: '/admin/CancelRevise',
    method: 'post',
    params: {
      contract_id,
    },
  }).then((res) => {
    var message = res.data?.message;
    if (message && message !== 'OK') {
      ElMessage({
        message,
        type: 'warning',
      });
      return;
    }
    ElMessage({
      message: 'Cancel revise success.',
      type: 'success',
    });
    search();
  });
};
</script>
<style scoped></style>
